<template>
  <div id="parts-box">
    <v-layout align-center justify-center row v-if="partsDetails.length > 0" wrap>
      <v-flex sm6 xs11>
        <div class="font-weight-bold headline head-page">ชิ้นส่วนที่นิยมซื้อขาย</div>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row wrap>
      <v-flex mb-3 sm6 xs11>
        <v-layout
          justify-center
          :key="index"
          row
          v-for="(partsDetail, index) in partsDetails.slice(0, loadmore)"
          wrap
        >
          <v-flex px-0 xs2>
            <v-img
              :aspect-ratio="4 / 4"
              class="grey lighten-2"
              cover
              :lazy-src="require('@/assets/NoPicture.png')"
              :src="partsDetail.picture ? partsDetail.picture : require('@/assets/NoPicture.png')"
            >
              <template v-slot:placeholder>
                <v-layout align-center fill-height justify-center ma-0>
                  <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-flex>
          <v-flex pt-1 xs9>
            <div class="body-2 font-weight-bold">
              {{ `${partsDetail.partsname || ''}${partsDetail.productname}` }}
              <span class="font-weight-light font-THSarabunNew">{{
                partsDetail.description || ''
              }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-3 pt-0 sm6 v-if="loadmore < partsDetails.length" xs11>
        <v-btn block @click="doLoadMore" depressed>ดูข้อมูลชิ้นส่วนเพิ่มเติม</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'parts-box',
  data() {
    return {
      loadmore: 5
    }
  },
  computed: {
    productId() {
      return window.atob(this.$route.params.productId)
    },
    partsDetails() {
      return this.$store.getters['Parts/getAll'].map(item => ({
        productname: item.productname,
        partsname: item.partsname,
        description: item.description,
        picture: item.picture
      }))
    }
  },
  created() {
    this.$store.dispatch('Parts/fetch', this.productId)
  },
  methods: {
    doLoadMore() {
      if (this.loadmore < this.partsDetails.length) this.loadmore += 5
    }
  }
}
</script>

<style lang="scss" scoped></style>
